import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "onboarding-layout__above-title" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "onboarding-layout__default-slot" }


export default /*@__PURE__*/_defineComponent({
  __name: 'Layout',
  props: {
    title: {},
    subtitle: {},
    scrollDefaultSlot: { type: Boolean },
    titleTransition: { type: Boolean },
    subtitleTransition: { type: Boolean },
    reverseTitleSubtitle: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["onboarding-layout", { 'onboarding-layout--scroll-default-slot': __props.scrollDefaultSlot }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "aboveTitle")
    ]),
    (__props.title || __props.subtitle)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["onboarding-layout__text", { 'onboarding-layout__text--reverse': __props.reverseTitleSubtitle }])
        }, [
          _createVNode(_Transition, {
            name: __props.titleTransition ? 'fade' : undefined,
            mode: __props.titleTransition ? 'out-in' : undefined
          }, {
            default: _withCtx(() => [
              (__props.title)
                ? (_openBlock(), _createElementBlock("h1", {
                    key: __props.titleTransition ? __props.title : undefined,
                    class: "onboarding-layout__title wg-no-merge",
                    innerHTML: __props.title
                  }, null, 8, _hoisted_2))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["name", "mode"]),
          _createVNode(_Transition, {
            name: __props.subtitleTransition ? 'fade' : undefined,
            mode: __props.subtitleTransition ? 'out-in' : undefined
          }, {
            default: _withCtx(() => [
              (__props.subtitle)
                ? (_openBlock(), _createElementBlock("p", {
                    key: __props.subtitleTransition ? __props.subtitle : undefined,
                    class: "onboarding-layout__subtitle",
                    innerHTML: __props.subtitle
                  }, null, 8, _hoisted_3))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["name", "mode"])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})